// Native interactions for the isolated copy; production analytics stay disabled here.
const rail = document.querySelector('#ss-gifts-page ').querySelector('.social-proof-rail');
document.querySelector('#ss-gifts-page ').querySelector('[aria-label="Previous videos"]').addEventListener('click', () => rail.scrollBy({left:-Math.min(720,innerWidth*.82),behavior:'smooth'}));
document.querySelector('#ss-gifts-page ').querySelector('[aria-label="Next videos"]').addEventListener('click', () => rail.scrollBy({left:Math.min(720,innerWidth*.82),behavior:'smooth'}));
document.querySelector('#ss-gifts-page ').querySelectorAll('.social-video-card').forEach(button => {
  button.addEventListener('click', () => {
    const modal = document.createElement('div');
    modal.className = 'video-modal';
    modal.setAttribute('role','dialog');
    modal.setAttribute('aria-modal','true');
    modal.setAttribute('aria-label','TikTok video by @'+button.dataset.gaCreator);
    const card = document.createElement('div');
    card.className = 'video-modal-card';
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'video-modal-close';
    close.setAttribute('aria-label','Close video');
    close.textContent = '\u00d7';
    const iframe = document.createElement('iframe');
    iframe.src = 'https://www.tiktok.com/player/v1/'+button.dataset.gaVideoId+'?autoplay=1&loop=0&rel=0&native_context_menu=0';
    iframe.title = button.dataset.gaLabel+' by @'+button.dataset.gaCreator;
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
    iframe.allowFullscreen = true;
    const link = document.createElement('a');
    link.href = 'https://www.tiktok.com/@'+button.dataset.gaCreator+'/video/'+button.dataset.gaVideoId;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.textContent = 'Watch on TikTok';
    card.append(close,iframe,link);
    modal.append(card);
    const originalOverflow = document.body.style.overflow;
    const dismiss = () => {
      modal.remove();
      document.body.style.overflow = originalOverflow;
      document.removeEventListener('keydown',keyHandler);
      button.focus();
    };
    const keyHandler = event => {
      if(event.key === 'Escape') {event.preventDefault();dismiss();}
      if(event.key === 'Tab') {
        if(event.shiftKey && document.activeElement === close) {event.preventDefault();link.focus();}
        else if(!event.shiftKey && document.activeElement === link) {event.preventDefault();close.focus();}
      }
    };
    close.addEventListener('click',dismiss);
    modal.addEventListener('click',event => {if(event.target === modal) dismiss();});
    document.addEventListener('keydown',keyHandler);
    document.body.append(modal);
    document.body.style.overflow = 'hidden';
    close.focus();
  });
});
